/*
 * 尾部组件：从"上传异常项照片"到最后
 * 异常照片 / 其它问题记录 / 备件耗材使用记录 / 维护总结 / 确认完成 / 异常项数量 / 结束人脸识别 / 确认正常结束 / 提交 & 取消
 * 依赖：common/core.js ui.js biz.js
 */
export default function installFooter(MW) {
  var h = MW.h, ui = MW.ui, biz = MW.biz, util = MW.util, store = MW.store, api = MW.api;
  var v = biz.v;

  var PAGE = 10;
  var page = { other_matter: 1, item_table: 1, item_table_temp: 1 };
  var swEndLoading = false, cacheLoading = false;
  var INT_RE = /^[+-]?\d+$/;
  var BILLING = ["维护耗材（全包）", "维护耗材（单独计费）", "备品备件（全包）", "备品备件（单独计费）"];

  /* ---------- 条件 ---------- */
  function lock() { return biz.isClosed(); }
  /** 备件填写模式：原表单默认"人工填写"（新版组件不渲染原字段，默认值不会写入，未设置时按人工填写处理） */
  function manual() { return (v("item_model_select") || "人工填写") === "人工填写"; }
  function itemKey() { return manual() ? "item_table_temp" : "item_table"; }
  function swEndEditable() { return !lock() && biz.allDone() && !!v("maintain_summary"); }
  function confirmEditable() {
    if (lock()) return false;
    return (biz.isSelf() && !!v("sw_end") && v("face_detect_result_end") !== biz.COMPARING && !util.isEmpty(v("face_photo_end"))) || biz.isLease();
  }

  /* ---------- 校验 ---------- */
  var OM_REQ = ["problem_item", "description_problem"];
  var IT_REQ = ["name", "model", "quantity", "ascription", "item_img_upload_1", "item_img_upload_2", "billing_model"];
  function rowErrors(tk, rows, req) {
    var e = [];
    (rows || []).forEach(function (r, i) {
      req.forEach(function (f) {
        if (util.isEmpty(r[f])) e.push({ key: tk + "." + i + "." + f, msg: "该字段是必填字段", table: tk, row: i });
        else if (f === "quantity" && !INT_RE.test(String(r[f]).trim())) e.push({ key: tk + "." + i + "." + f, msg: "该字段不是有效的整数", table: tk, row: i });
      });
    });
    return e;
  }
  function allErrors() {
    var e = [];
    e = e.concat(rowErrors("other_matter", v("other_matter"), OM_REQ));
    e = e.concat(rowErrors(itemKey(), v(itemKey()), IT_REQ));
    biz.req(e, "maintain_summary", v("maintain_summary"));
    biz.req(e, "sw_end", v("sw_end"), "请打开开关");
    biz.req(e, "abnormal_confirm", v("abnormal_confirm"), "请打开开关");
    if (biz.isSelf()) biz.req(e, "face_photo_end", v("face_photo_end"));
    biz.req(e, "confirm", v("confirm"));
    return e;
  }

  /* ---------- 交互逻辑 ---------- */
  /** 确认完成：先拉一次最新数据再判断；已被他人打开时提示，不重复记录时间 */
  function onSwEnd(val) {
    var sync = MW.sync;
    swEndLoading = true;
    store.touch("sw_end");
    sync.fresh()
      .then(function () {
        if (val && v("sw_end")) return sync.doneBy("sw_end", "确认完成", "打开");
        if (val && !swEndEditable()) return ui.toast("数据已更新，请按最新状态操作", "warn");
        store.patch({
          txt_end: val ? util.now() : biz.TXT_END,
          abnormal_count: val ? biz.countAbnormal() + (v("other_matter") || []).length : v("abnormal_count"),
          sw_end: val,
        });
        return sync.commit(["txt_end", "abnormal_count", "sw_end"], val ? ["sw_end"] : []).then(function (r) {
          if (r && r.code === 1) sync.doneBy("sw_end", "确认完成", "打开", r.rejected);
          else if (val && r && r.offline) ui.toast("已确认完成（当前无网络，已暂存在本机），联网上传后才能提交工单", "info");
        });
      })
      .catch(function (e) {
        if (util.isNetErr(e)) return ui.toast("网络不稳定，操作已暂存，联网后自动上传", "warn");
        ui.toast("保存失败：" + (util.errMsg(e) || "服务异常") + "，将自动重试", "danger");
      })
      .then(function () {
        swEndLoading = false;
        store.touch("sw_end");
      });
  }

  function onSummaryInput(val) {
    store.set("maintain_summary", val, { silent: true });
    MW.sync.typing("maintain_summary");
    // 输入过程中不重绘（避免打断中文输入法），直接同步"确认完成"开关的可编辑状态
    var sw = MW.$('.mw-part--footer [data-key="sw_end"]');
    if (!sw) return;
    var ok = swEndEditable();
    sw.classList.toggle("is-disabled", !ok);
    var btn = sw.querySelector(".mw-switch");
    if (btn) { btn.disabled = !ok; btn.classList.toggle("is-disabled", !ok); }
  }
  /** 失焦立即保存（原逻辑只在内容为数字时才保存，多人协同时会丢内容，改为始终保存） */
  function onSummaryBlur() {
    MW.sync.save("maintain_summary");
    store.touch("maintain_summary");
  }

  /** 读取缓存：原逻辑 context 仅含 service_name / method_name，不带 $context */
  function loadCache() {
    // 缓存存放在服务器上，必须联网读取
    if (MW.net.offline) return MW.offline.needNet("读取缓存");
    cacheLoading = true;
    store.touch("item_table_temp");
    api.raw({ service_name: "SubNormalMaintenance", method_name: "load_item_cache" }, {})
      .then(function (res) {
        var data = res && res.data;
        cacheLoading = false;
        if (data && data.result) {
          page.item_table_temp = 1;
          store.set("item_table_temp", data.result.item_table);
          MW.sync.save("item_table_temp");
          ui.toast("成功", "ok");
        } else {
          store.touch("item_table_temp");
          ui.alert("失败");
        }
      }, function (e) {
        cacheLoading = false;
        store.touch("item_table_temp");
        if (util.isNetErr(e)) return MW.offline.needNet("读取缓存");
        ui.alert("失败");
      });
  }

  function onConfirm(val) {
    store.set("confirm", val);
    biz.inputUpdate("confirm", val);
    if (val === "异常") {
      ui.alert(
        "<div class='color-danger'>此处选择“异常”将触发维护红灯，红灯判断依据如下：</div>" +
          "<div>1、维护过程中发现重大风险或故障，维护无法继续，需中止。</div>" +
          "<div>2、维护时发现设备有重大隐患，设备无法再投入使用（冗余性降低）。</div>",
        { title: "提示", showCancel: true }
      ).catch(function () {});
    }
  }

  /* ---------- 校验钩子：提交/取消由平台表单自带按钮负责，这里只负责把分页表格翻到首个错误页 ---------- */
  function jumpToErrorPage(errs) {
    var moved = false;
    ["other_matter", "item_table", "item_table_temp"].forEach(function (tk) {
      var e = errs.filter(function (x) { return x.table === tk; })[0];
      if (e) { var p = Math.floor(e.row / PAGE) + 1; if (page[tk] !== p) { page[tk] = p; moved = true; } }
    });
    if (moved) MW.parts.footer.repaint();
  }

  /* ---------- 渲染：可编辑表格（other_matter / item_table / item_table_temp 复用） ---------- */
  function editTable(o, ctx) {
    var tk = o.key;
    var rows = v(tk) || [];
    var dis = lock();
    var pages = Math.max(1, Math.ceil(rows.length / PAGE));
    if (page[tk] > pages) page[tk] = pages;
    var start = (page[tk] - 1) * PAGE;
    var view = rows.slice(start, start + PAGE);
    function setRows(n) { store.set(tk, n); MW.sync.save(tk); }
    function move(i, d) {
      var j = i + d;
      if (j < 0 || j >= rows.length) return;
      var n = rows.slice();
      var t = n[i]; n[i] = n[j]; n[j] = t;
      setRows(n);
    }
    var cols = [{ title: "序号", cls: "is-idx", mobileHead: true, render: function (r, i) {
      var gi = start + i;
      return [h("span", { class: "mw-idx" }, gi + 1), !dis && h("span", { class: "mw-ops mw-ops--m" }, opsBtns(gi))];
    } }];
    function opsBtns(gi) {
      return [
        ui.btn("", { type: "text", size: "sm", icon: "ri-arrow-up-line", title: "上移", disabled: gi === 0, onClick: function () { move(gi, -1); } }),
        ui.btn("", { type: "text", size: "sm", icon: "ri-arrow-down-line", title: "下移", disabled: gi === rows.length - 1, onClick: function () { move(gi, 1); } }),
        ui.btn("", { type: "text-danger", size: "sm", icon: "ri-delete-bin-6-line", title: "删除", onClick: function () {
          var n = rows.slice(); n.splice(gi, 1); setRows(n);
        } }),
      ];
    }
    o.columns.forEach(function (c) {
      cols.push({
        title: c.title, required: c.required, width: c.width, mobileFull: c.full,
        render: function (r, i) {
          var gi = start + i;
          var err = ctx.err(tk + "." + gi + "." + c.key);
          return h("div", { class: ["mw-cell", err && "has-error"] }, c.render(r, gi, dis), err && h("div", { class: "mw-field__error" }, h("i", { class: "ri-error-warning-fill" }), err));
        },
      });
    });
    if (!dis) cols.push({ title: "操作", cls: "is-ops mw-ops--pc", render: function (r, i) { return h("span", { class: "mw-ops" }, opsBtns(start + i)); } });

    return h(
      "div",
      { class: ["mw-etable", o.cls] },
      ui.rtable({ columns: cols, rows: view, empty: o.empty || "暂无记录，点击下方【添加】" }),
      h("div", { class: "mw-etable__foot" },
        !dis && ui.btn("添加", { type: "ghost", icon: "ri-add-circle-line", cls: "mw-etable__add", onClick: function () {
          var n = rows.concat([{}]);
          page[tk] = Math.ceil(n.length / PAGE);
          setRows(n);
        } }),
        pager(tk, rows.length, pages))
    );
  }
  function pager(tk, total, pages) {
    var cur = page[tk];
    function go(p) { page[tk] = p; MW.parts.footer.repaint(); }
    var nums = [];
    for (var p = 1; p <= pages; p++) nums.push(p);
    return h("div", { class: "mw-pager" },
      h("span", { class: "mw-pager__total" }, "共 " + total + " 条"),
      pages > 1 && [
        h("button", { type: "button", disabled: cur <= 1, onClick: function () { go(cur - 1); } }, h("i", { class: "ri-arrow-left-s-line" })),
        nums.map(function (n) { return h("button", { type: "button", class: n === cur ? "is-on" : null, onClick: function () { go(n); } }, n); }),
        h("button", { type: "button", disabled: cur >= pages, onClick: function () { go(cur + 1); } }, h("i", { class: "ri-arrow-right-s-line" })),
      ]);
  }

  /** 表格按整表保存（行可增删/移动，按下标保存会错位）；选择类立即保存 */
  function cellSave(tk) { store.touch(tk); MW.sync.save(tk); }
  /** 单元格控件工厂：键入 silent 写入并 1 秒防抖保存，失焦立即保存并重绘（刷新校验提示） */
  function cellInput(r, f, gi, dis, tk, o) {
    o = o || {};
    return ui.input({
      name: tk + "_" + gi + "_" + f, value: r[f], placeholder: o.placeholder || "请输入", disabled: dis, inputmode: o.inputmode,
      onInput: function (val) { r[f] = val; MW.sync.typing(tk); }, onBlur: function () { MW.sync.save(tk); store.touch(tk); },
    });
  }
  function cellText(r, f, gi, dis, tk) {
    return ui.textarea({ name: tk + "_" + gi + "_" + f, value: r[f], rows: 2, disabled: dis, onInput: function (val) { r[f] = val; MW.sync.typing(tk); }, onBlur: function () { MW.sync.save(tk); store.touch(tk); } });
  }
  function cellUpload(r, f, max, dis, tk) {
    var up = ui.upload({ value: r[f], maxCount: max || 9, accept: "image/*", text: "选择图片", disabled: dis, onChange: function (l) { r[f] = l; cellSave(tk); } });
    up.classList.add("mw-upload--sm");
    return up;
  }

  function itemColumns(tk) {
    var isManual = tk === "item_table_temp"; // 系统选择表 item_table 的名称是"ID,名称"格式（后端结单时拆分），只能下拉选择
    return [
      { title: "备件耗材名称", key: "name", required: true, width: "150px", full: true, render: function (r, gi, dis) {
        return isManual ? cellInput(r, "name", gi, dis, tk, { placeholder: "请输入备件耗材名称" })
          : ui.select({ value: r.name, options: v("item_list") || [], disabled: dis, onChange: function (val) { r.name = val; cellSave(tk); } });
      } },
      { title: "型号", key: "model", required: true, width: "120px", render: function (r, gi, dis) { return cellInput(r, "model", gi, dis, tk); } },
      { title: "SN（每行仅填写1个SN，无SN可不填）", key: "sn", width: "170px", full: true, render: function (r, gi, dis) { return cellInput(r, "sn", gi, dis, tk, { placeholder: "无SN可不填" }); } },
      { title: "数量", key: "quantity", required: true, width: "80px", render: function (r, gi, dis) { return cellInput(r, "quantity", gi, dis, tk, { inputmode: "numeric", placeholder: "整数" }); } },
      { title: "来源", key: "ascription", required: true, width: "170px", full: true, render: function (r, gi, dis) {
        return ui.radio({ options: ["服务商", "腾讯"], value: r.ascription, disabled: dis, block: true, onChange: function (val) { r.ascription = val; cellSave(tk); } });
      } },
      { title: "更换前照片", key: "item_img_upload_1", required: true, full: true, render: function (r, gi, dis) { return cellUpload(r, "item_img_upload_1", 9, dis, tk); } },
      { title: "更换后照片", key: "item_img_upload_2", required: true, full: true, render: function (r, gi, dis) { return cellUpload(r, "item_img_upload_2", 9, dis, tk); } },
      { title: "计费模式", key: "billing_model", required: true, width: "170px", full: true, render: function (r, gi, dis) {
        return ui.select({ value: r.billing_model, options: BILLING, disabled: dis, onChange: function (val) { r.billing_model = val; cellSave(tk); } });
      } },
    ];
  }

  /* ---------- 渲染：各区块 ---------- */
  function abnormalPhotos() {
    var steps = biz.countAbnormal();
    return ui.panel(
      { title: "异常项照片", icon: "ri-image-add-line", id: "mw-upload-end", extra: steps ? ui.tag("检查清单异常 " + steps + " 项", "warn", "ri-alarm-warning-line") : ui.tag("检查清单无异常", "ok") },
      ui.field({ label: "上传异常项照片", desc: "如上述检查项中存在异常，请在此上传照片" },
        ui.upload({ value: v("upload_end"), maxCount: 20, accept: ".png,.jpg,.jpeg", text: "选择图片", disabled: lock(), onChange: function (l) { store.set("upload_end", l); biz.inputUpdate("upload_end", l); } }))
    );
  }

  function otherMatter(ctx) {
    var rows = v("other_matter") || [];
    return ui.panel(
      { title: "其它问题记录", icon: "ri-question-answer-line", id: "mw-other", sub: "如发现的问题不在上述检查项内请在此记录", extra: rows.length ? ui.tag(rows.length + " 条", "warn") : null },
      editTable({
        key: "other_matter", empty: "暂无其它问题",
        columns: [
          { title: "问题项", key: "problem_item", required: true, width: "200px", full: true, render: function (r, gi, dis) { return cellInput(r, "problem_item", gi, dis, "other_matter"); } },
          { title: "问题详细描述", key: "description_problem", required: true, full: true, render: function (r, gi, dis) { return cellText(r, "description_problem", gi, dis, "other_matter"); } },
          { title: "上传问题照片", key: "problem_upload", width: "250px", full: true, render: function (r, gi, dis) { return cellUpload(r, "problem_upload", 3, dis, "other_matter"); } },
        ],
      }, ctx)
    );
  }

  /**
   * 修复前未设置填写模式时，新增行误写入系统选择表 item_table（名称下拉为空）。
   * 这些行没有"ID,名称"格式的名称，留在 item_table 会让结单拆分名称时报错，这里一次性并入人工填写表。
   */
  var migrating = false;
  function migrateItems() {
    if (migrating || lock() || v("item_model_select")) return;
    var old = v("item_table");
    if (!Array.isArray(old) || !old.length) return;
    migrating = true;
    setTimeout(function () {
      var cur = v("item_table");
      if (Array.isArray(cur) && cur.length && !lock() && !v("item_model_select")) {
        store.set("item_table_temp", (v("item_table_temp") || []).concat(cur));
        store.set("item_table", []);
        MW.sync.save("item_table_temp");
        MW.sync.save("item_table");
      }
      migrating = false;
    }, 0);
  }

  function items(ctx) {
    migrateItems();
    var tk = itemKey();
    var rows = v(tk) || [];
    return ui.panel(
      {
        title: "备件耗材使用记录", icon: "ri-archive-drawer-line", id: "mw-items", sub: "本次维护如之前工单有填写下表，可点击读取缓存导入上一工单填写的内容",
        extra: [
          h("span", { class: "mw-mode" }, h("small", null, "备件填写模式"), ui.tag(v("item_model_select") || "人工填写", "info", manual() ? "ri-edit-2-line" : "ri-list-settings-line")),
          ui.btn("读取缓存", { type: "primary", size: "sm", icon: "ri-download-cloud-2-line", loading: cacheLoading, disabled: lock(), onClick: loadCache }),
        ],
      },
      h("div", { class: "mw-field__desc mw-items__desc" }, h("i", { class: "ri-information-line" }), "如此设备维护过程中有使用备件或耗材，需按实际用量填写"),
      editTable({ key: tk, columns: itemColumns(tk), empty: "未使用备件耗材", cls: "mw-etable--items" }, ctx),
      rows.length > 0 && h("div", { class: "mw-items__sum" },
        h("span", null, "共 ", h("b", null, rows.length), " 种"),
        h("span", null, "合计数量 ", h("b", null, rows.reduce(function (a, r) { var n = parseInt(r.quantity, 10); return a + (isNaN(n) ? 0 : n); }, 0))))
    );
  }

  /** 异常项清单：检查清单异常（编号 + 名称 + 异常部位/描述）+ 其它问题记录（问题项 + 描述），供核对异常项数量 */
  function abnList() {
    var rows = biz.abnormalList().map(function (a) { return { tag: "检查项", sn: a.sn, title: a.title, desc: a.desc }; })
      .concat((v("other_matter") || []).map(function (r, i) {
        return { tag: "其它问题", sn: String(i + 1), title: String(r.problem_item || "").trim() || "（未填写问题项）", desc: String(r.description_problem || "").trim() };
      }));
    if (!rows.length) return h("div", { class: "mw-abn__empty" }, h("i", { class: "ri-checkbox-circle-line" }), "检查清单与其它问题记录中均无异常项");
    return h("div", { class: "mw-abn__list" },
      h("div", { class: "mw-abn__list-hd" }, h("i", { class: "ri-list-unordered" }), h("span", null, "异常项清单（", h("b", null, rows.length), " 项）")),
      h("ol", null, rows.map(function (r) {
        return h("li", null,
          h("span", { class: ["mw-abn__tag", r.tag === "检查项" ? "is-ck" : "is-om"] }, r.tag + " " + r.sn),
          h("span", { class: "mw-abn__title" }, r.title),
          r.desc && h("span", { class: "mw-abn__desc" }, r.desc));
      })));
  }

  function finish(ctx) {
    var swOk = swEndEditable();
    var on = !!v("sw_end");
    var cnt = Number(v("abnormal_count") || 0);
    var tip = null;
    if (!swOk && !lock() && !on) tip = !biz.allDone() ? "完成全部维护步骤后可确认" : "填写维护总结后可确认";
    return ui.panel(
      { title: "维护收尾", icon: "ri-flag-2-line", id: "mw-finish", sub: "维护总结 · 确认完成 · 异常确认" },
      ui.field({ label: "维护总结", required: true, key: "maintain_summary", error: ctx.err("maintain_summary") },
        ui.textarea({ name: "maintain_summary", value: v("maintain_summary"), rows: 4, counter: true, maxlength: 1000, placeholder: "请填写本次维护的总体情况、处理过程及遗留问题", disabled: lock(), onInput: onSummaryInput, onBlur: onSummaryBlur })),
      biz.switchRow({
        title: "确认完成", required: true, key: "sw_end", icon: "ri-checkbox-circle-line", time: v("txt_end") || biz.TXT_END,
        value: on, disabled: !swOk, loading: swEndLoading, onChange: onSwEnd, error: ctx.err("sw_end"), tip: tip, cls: "mw-swrow--end",
      }),
      h("div", { class: ["mw-abn", cnt > 0 && "is-danger"] },
        h("div", { class: "mw-abn__num" }, h("small", null, "异常项数量"), h("b", null, cnt), h("span", null, "检查清单异常 + 其它问题记录")),
        h("div", { class: "mw-abn__ctrl" },
          on && abnList(),
          biz.switchRow({
            title: "确认异常项数量无误", required: true, key: "abnormal_confirm", icon: "ri-shield-check-line",
            time: v("abnormal_confirm") ? "已确认" : on ? "请核对异常项数量" : "确认完成后可操作",
            value: !!v("abnormal_confirm"), disabled: lock() || !on, error: ctx.err("abnormal_confirm"),
            onChange: function (val) { store.set("abnormal_confirm", val); biz.inputUpdate("abnormal_confirm", val); },
          }),
          v("abnormal_ticket_id") && ui.field({ label: "异常问题跟进单" }, ui.link(biz.ticketUrl(v("abnormal_ticket_id")), biz.ticketUrl(v("abnormal_ticket_id")) || v("abnormal_ticket_id"))))),
      biz.isSelf() &&
        biz.faceSection({
          suffix: "_end", title: "维护结束前，请拍照进行人脸识别", editable: !lock() && on, qualMethod: "get_qualification_res",
          errors: { face_photo_end: ctx.err("face_photo_end") }, lockTip: "打开【确认完成】后可拍照上传",
        }),
      ui.field({ label: "确认正常结束", required: true, key: "confirm", error: ctx.err("confirm"),
        desc: confirmEditable() ? "选择“异常”将触发维护红灯" : lock() ? null : biz.isSelf() ? "确认完成并完成结束人脸识别后可选择" : null },
        ui.radio({ options: ["正常", "异常"], value: v("confirm"), disabled: !confirmEditable(), onChange: onConfirm, cls: "mw-confirm" }))
    );
  }

  biz.part({
    name: "footer",
    title: "维护收尾",
    render: function (ctx) {
      return h(
        "div",
        { class: "mw-footer" },
        abnormalPhotos(),
        otherMatter(ctx),
        items(ctx),
        finish(ctx)
      );
    },
    errors: allErrors,
  });
  var footerPart = MW.parts.footer;
  var rawValidate = footerPart.validate;
  footerPart.validate = function () {
    var list = rawValidate();
    jumpToErrorPage(list);
    return list;
  };
}
